<template>
  <div>
    <div v-if="loading" style="text-align: center">
      <md-progress-spinner
        class="md-accent"
        md-mode="indeterminate"
        :md-diameter="500"
        :md-stroke="10"
      />
    </div>
    <div v-if="!loading">
      <div class="row" style="align-items: center">
        <div class="hover-cursor ml-2 hover-cursor" @click="$router.back()">
          <md-icon class=""> arrow_back </md-icon>
        </div>
        <div class="col">
          <p class="md-title mb-0">
            {{ equipamento.nome }} -
            {{ acao ? acao.nomeExibicao : 'Nova Ação' }}
          </p>
          <p class="md-caption mt-0" style="font-size: 1rem">
            {{ equipamento.descricao }}
          </p>
        </div>
      </div>
      <form @submit.prevent="submitAcaoForm">
        <div class="row pl-4">
          <div class="col-6">
            <md-field :class="getValidationAcao('nomeExibicao')">
              <label for="nomeExibicao">Nome de Exibição</label>
              <md-input id="nomeExibicao" v-model="form.nomeExibicao" />
              <span v-if="!$v.form.nomeExibicao.required" class="md-error"
                >Um nome de exibição é requerido</span
              >
            </md-field>

            <md-field :class="getValidationAcao('acao')">
              <label for="acao">Comando que será enviado</label>
              <md-input id="acao" v-model="form.acao" />
              <span v-if="!$v.form.acao.required" class="md-error"
                >Uma ação é requerida</span
              >
            </md-field>
            <md-switch v-model="form.apenasAdminExecuta">
              Restrito ao Administrador
            </md-switch>
            <br />
            <br />
            <material-picker v-model="form.cor" />
            <br />
            <br />
            <md-divider />

            <md-card-header style="padding-bottom: 0">
              <p class="md-subheading mb-0">Mobile</p>
            </md-card-header>

            <md-field :class="getValidationAcao('smsConteudo')">
              <label for="smsConteudo">Conteudo SMS</label>
              <md-input id="smsConteudo" v-model="form.smsConteudo" />
              <span v-if="!$v.form.smsConteudo.required" class="md-error"
                >Uma ação é requerida</span
              >
            </md-field>

            <md-field :class="getValidationAcao('dialogoConteudo')">
              <label for="dialogoConteudo">Diálogo conteudo</label>
              <md-input id="dialogoConteudo" v-model="form.dialogoConteudo" />
              <span v-if="!$v.form.dialogoConteudo.required" class="md-error"
                >Um Diálogo é requerido</span
              >
            </md-field>

            <md-switch v-model="form.dialogoContinuar">
              Dialogo de continuar
            </md-switch>

            <md-switch v-model="form.esperaRetorno"> Espera retorno </md-switch>

            <md-card-actions>
              <md-button
                v-if="acao"
                class="md-accent md-raised"
                :disabled="loading"
                @click="excluirModal = true"
              >
                Excluir
              </md-button>
              <md-button
                class="md-accent"
                :disabled="loading"
                @click="cancelEdit"
              >
                Cancelar
              </md-button>
              <md-button type="submit" class="md-primary" :disabled="loading">
                {{ acao ? 'Editar' : 'Adicionar' }}
              </md-button>
            </md-card-actions>
          </div>
          <div class="col-6">
            <md-card-header style="padding-bottom: 0">
              <div class="row">
                <div class="col-6">
                  <p class="md-subheading mb-0">Parametrização</p>
                  <p class="md-caption">Adicione $VALOR ao comando</p>
                </div>
                <div class="col-6">
                  <p>Calculado pela regra de 3</p>
                  <p style="text-align: justify">
                    {{ form.xMax || 'xMax' }}
                    <md-icon>arrow_right_alt</md-icon>
                    {{ form.yMax === 0 ? 'yMax' : form.yMax }}
                    <br />
                    Valor usuário
                    <md-icon>arrow_right_alt</md-icon>
                    Valor enviado
                  </p>
                </div>
              </div>
            </md-card-header>
            <md-field :class="getValidationAcao('xMax')">
              <label for="xMax">xMax (Valor máximo do usuário)</label>
              <md-input id="xMax" v-model="form.xMax" type="number" />
            </md-field>
            <md-field :class="getValidationAcao('yMax')">
              <label for="yMax">yMax</label>
              <md-select id="movie" v-model="form.yMax" name="movie">
                <md-option :value="0"> Nulo </md-option>
                <md-option :value="8192"> CFW 500/700 </md-option>
                <md-option :value="20000"> ABB </md-option>
                <md-option :value="16384"> Danfos Aqua</md-option>
                <md-option :value="60"> Schneider</md-option>
              </md-select>
            </md-field>
            <md-divider />
          </div>
        </div>
      </form>
    </div>
    <md-dialog-confirm
      :md-active="excluirModal"
      md-title="Tem certeza?"
      md-content="Deseja realmente excluir essa ação?"
      md-confirm-text="deletar"
      md-cancel-text="cancelar"
      @md-clicked-outside="excluirModal = false"
      @md-cancel="excluirModal = false"
      @md-confirm="deletarAcao(acao.id)"
    />
  </div>
</template>

<script>
import { Compact } from 'vue-color'
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'

import http from '../../utils/http'

export default {
  name: 'EquipamentoAcaoForm',
  components: {
    'material-picker': Compact,
  },
  mixins: [validationMixin],
  data() {
    return {
      excluirModal: false,
      equipamentoId: null,
      localId: null,
      acaoId: null,
      acao: null,
      equipamento: null,
      loading: true,
      form: {
        cor: '#ffffff',
        acao: null,
        nomeExibicao: null,
        smsConteudo: null,
        dialogoConteudo: null,
        dialogoContinuar: false,
        esperaRetorno: false,
        apenasAdminExecuta: false,
        xMax: null,
        yMax: 0,
      },
    }
  },
  async beforeMount() {
    if (this.$route.params.equipamentoId && this.$route.params.localId) {
      this.equipamentoId = this.$route.params.equipamentoId
      this.localId = this.$route.params.localId

      if (this.$route.params.acaoId) {
        this.acaoId = this.$route.params.acaoId
      }

      await this.loadData(this.equipamentoId)
    }
  },
  methods: {
    deletarAcao(acaoId) {
      this.loading = true

      this.excluirModal = false

      http
        .delete(`equipamento/${this.equipamentoId}/gerenciar/acao/`, acaoId)
        .then((e) => {
          if (e) {
            this.$router.back()
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    async loadData(equipamentoId) {
      this.loading = true

      const promises = [
        http.get(`equipamento/${equipamentoId}`).then((data) => {
          this.equipamento = data.equipamento
        }),
        http
          .get(`equipamento/${equipamentoId}/botao`)
          .then(({ botoes }) =>
            botoes.map((e) => {
              return {
                ...e,
                cor: e.cor,
              }
            })
          )
          .then((e) => (this.acoes = e)),
      ]

      await Promise.all(promises)
        .then(() => {
          if (this.acaoId) {
            this.acao = this.equipamento.botoesAcaoEquipamento.find(
              (e) => e.id === this.acaoId
            )

            this.form = {
              ...this.acao,
              yMax: +this.acao.yMax,
            }
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    getValidationAcao(fieldName) {
      const field = this.$v.form[fieldName]

      if (field) {
        return {
          'md-invalid': field.$error,
        }
      }
    },
    getAcaoToSend() {
      return {
        ...this.form,
        cor: this.form.cor.hex || this.form.cor,
      }
    },
    editAcao() {
      http
        .put(
          `equipamento/${this.equipamentoId}/gerenciar/acao/${this.acaoId}`,
          this.getAcaoToSend()
        )
        .then((e) => {
          if (e) {
            this.$router.back()
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    createAcao() {
      http
        .post(
          `equipamento/${this.equipamentoId}/gerenciar/acao`,
          this.getAcaoToSend()
        )
        .then((e) => {
          if (e) {
            this.$router.back()
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    cancelEdit() {
      this.$router.back()
    },
    submitAcaoForm() {
      this.$v.$touch()

      if (!this.$v.$invalid) {
        // eslint-disable-next-line no-unreachable
        this.loading = true
        try {
          if (this.acao) {
            this.editAcao()
          } else {
            this.createAcao()
          }
        } finally {
          this.loading = false
        }
      }
    },
  },
  validations: {
    form: {
      acao: {
        required,
      },
      nomeExibicao: {
        required,
      },
      smsConteudo: {
        required,
      },
      dialogoConteudo: {
        required,
      },
    },
  },
}
</script>
